import { post } from "../utils/backend";
import { ProductAudit, AuditRequest } from "../models/ProductAudit";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/productAuditMock";

const getAllCandidates = async (): Promise<ProductAudit[]> => {
    if (mock&&false) {
        return getMockData("audit_candidates");
    }
    const resultOrErrorCode = await post<null, ProductAudit[]>("/audit/product/getAllCandidates", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessed = async (): Promise<ProductAudit[]> => {
    if (mock&&false) {
        return getMockData("audit_processed");
    }
    const resultOrErrorCode = await post<null, ProductAudit[]>("/audit/product/getAllProcessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const productAudit = async (params: AuditRequest): Promise<boolean> => {
    if (mock && false) {
        return true;
    }
    const resultOrErrorCode = await post<Record<string, unknown>, boolean>("/audit/product/audit", {
        draftId: params.draftId,
        approved: params.approved,
        reason: params.refuseReason,
        refuseReason: params.refuseReason,
    });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const productAuditApi = {
    getAllCandidates,
    getAllProcessed,
    productAudit
}; 